import {all, call, fork, put, takeEvery} from 'redux-saga/effects'
import {
  UsersActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from '@actions/user';
import {updateSuccess as updateCurrentUser} from '@actions/auth';
import userApi from '@api/user';
import {ReduxAction} from "@actions/index";
import {RequestData} from "@models/axios";
import {fetchCurrentUserError, fetchCurrentUserSuccess} from "../actions/user";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(userApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(userApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload, params}: ReduxAction) {
  try {
    const {data} = yield call(userApi.create, payload);
    yield setRoles({
      params: {
        id: data.id,
      },
      payload: payload.payload
    });
    
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(userApi.update, payload);
    yield setRoles({
      params: {
        id: data.id,
      },
      payload: payload.payload
    });
    
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data));
    yield put(updateCurrentUser(data));
  }
  catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* setRoles({params, payload}: RequestData) {
  try {
    const {roles} = payload;
    const {new_roles, deleted_roles} = roles;
    if (new_roles.length > 0) {
      yield call(userApi.setRoles, {
        params,
        payload: {
          role_ids: new_roles
        }
      });
    }
    if (deleted_roles.length > 0) {
      yield call(userApi.deleteRoles, {
        params,
        payload: {
          role_ids: deleted_roles
        }
      });
    }
  } catch (err) {
  
  }
}


function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(userApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  } catch (err) {
    yield put(fetchItemError(err))
  }
}

function* handleFetchCurrentUser() {
  try {
    const {data} = yield call(userApi.getCurrentUser);
    yield put(fetchCurrentUserSuccess(data))
  } catch (err) {
    yield put(fetchCurrentUserError(err))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* usersSaga() {
  yield all([
    yield takeEvery(UsersActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(UsersActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(UsersActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(UsersActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(UsersActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
    yield takeEvery(UsersActionTypes.FETCH_CURRENT_USER_REQUEST, handleFetchCurrentUser),
  ])
}

export default usersSaga
